
import React, { useEffect, useId, useState } from 'react';



const FunctionView = () => {
 const [role, setRole] = useState('Elev');
   const [userId, setUserId] = useState('123e4567-e89b-12d3-a456-426614174793');
   const [service, setService] = useState('EDUCATION');
   const [theme, setTheme] = useState('Dashboard');
   const [school, setSchool] = useState('Grundskola');
   const [isLoaded, setIsLoaded] = useState(false);
 

   const styles = {
    app: { fontFamily: 'Arial, sans-serif', textAlign: 'center', width: '100%' },
    header: { padding: '20px' },
    main: { padding: '20px', height: '70vh' },
    
    inputGroup: { marginBottom: '15px' },
    label: { display: 'block', fontWeight: 'bold', marginBottom: '5px' },
    select: { width: '100%', padding: '10px', fontSize: '16px' },
    input: { width: '100%', padding: '10px', fontSize: '16px' },
    button: { backgroundColor: '#4CAF50', color: 'white', border: 'none', padding: '10px 20px', cursor: 'pointer', fontSize: '16px', marginTop: '10px' },
  };
   useEffect(() => {
     const fetchScript = async () => {
       try {
         console.log(1)
         const response = await fetch(`https://haldor-infoapp-test.azurewebsites.net/api/WebComponent?role=${role}&userId=${userId}&service=${service}&theme=${theme}&school=${school}`);
         if (!response.ok) {
           throw new Error(`Failed to load script: ${response.statusText}`);
         }
         const scriptText = await response.text();
 
         // Kontrollera om skriptet redan har laddats för att undvika att registrera webkomponenten på nytt
         const existingScript = document.getElementById('web-component-script');
         if (!existingScript) {
           const script = document.createElement("script");
           script.id = 'web-component-script';  // Ge skriptet ett unikt id
           script.innerHTML = scriptText;
           document.body.appendChild(script);
         }
         
         setIsLoaded(true);
       } catch (error) {
         console.error("Error fetching web component script:", error);
       }
     };
 
     fetchScript();
     
   }, []); 
  
   
   return (
    <div style={styles.app}>
    <header style={styles.header}>
      <h1 style={styles.heading}>HALDOR FRONT END : TEST</h1>
    </header>
    <h4>User:</h4>
    <p>USERID: {userId}</p>
    <p>ROLE: {role}</p>
    <p>SCHOOL: {school}</p>
    <p>FUNCTION: {theme}</p>
    <main style={styles.main}>
      {/* <h3>Uppdatera Profil</h3>

      <div style={styles.inputGroup}>
        <label style={styles.label}>Roll:</label>
        <select style={styles.select} value={role} onChange={(e) => setRole(e.target.value)}>
          {rolesList.map(option => <option key={option.value} value={option.value}>{option.label}</option>)}
        </select>
      </div>

      <div style={styles.inputGroup}>
        <label style={styles.label}>User ID:</label>
        <input type="text" style={styles.input} value={userId} onChange={(e) => setUserId(e.target.value)} />
      </div>

      <div style={styles.inputGroup}>
        <label style={styles.label}>Service:</label>
        <input type="text" style={styles.input} value={service} onChange={(e) => setService(e.target.value)} />
      </div>

      <div style={styles.inputGroup}>
        <label style={styles.label}>Tema:</label>
        <select style={styles.select} value={theme} onChange={(e) => setTheme(e.target.value)}>
          {functionsList.map(option => <option key={option.value} value={option.value}>{option.label}</option>)}
        </select>
      </div>

      <div style={styles.inputGroup}>
        <label style={styles.label}>Skolform:</label>
        <select style={styles.select} value={school} onChange={(e) => setSchool(e.target.value)}>
          {schoolFormsList.map(option => <option key={option.value} value={option.value}>{option.label}</option>)}
        </select>
      </div> */}

      

      <div>
        <h3>Web Component</h3>
        {isLoaded ? <web-component-handler></web-component-handler> : <p>Det finns inga nyheter för dig..</p>}
      </div>
    </main>
  </div>
   );
}

export default FunctionView